import { MuiPickersAdapterContext } from '@mui/x-date-pickers';
import { useContext } from 'react';

const useMuiPickersLocale = () => {
  const value = useContext(MuiPickersAdapterContext);
  return value?.utils?.locale as Locale;
};

export default useMuiPickersLocale;
